import type { FC } from 'react';
import React, { useState } from 'react';

import { Box, Typography } from '@mui/material';

import { ArrowRightBigIcon } from '@setup/svg-icons/svg-icons';
import { MuiButton } from '@shared/ui-kit';
import { NotificationBlockContainer } from '@shared/ui-kit/alerts/NotificationBlock/NotificationBlock.style';
import { notificationVariantConfig } from '@shared/ui-kit/alerts/NotificationBlock/configs/notifiactionVariantConfig';

import type { MuiButtonProps } from '@shared/ui-kit';

export type CustomBtnProps = MuiButtonProps & {
  isShow: boolean;
  isLoadingBtn?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
};

type NotificationBlockType = {
  label: string;
  labelColor?: string;
  isHideBoxShadow?: boolean;
  isClickable?: boolean;
  callback?: () => void;
  variant?: 'info' | 'warning';
  customBtnProps?: CustomBtnProps;
};

// TODO change and remove this componet to MuiAlert

export const NotificationBlock: FC<NotificationBlockType> = ({
  label,
  labelColor,
  isHideBoxShadow,
  callback,
  isClickable,
  customBtnProps,
  variant = 'info',
}) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    if (isClickable) {
      callback?.();
      setIsClicked(true);
      setTimeout(() => setIsClicked(false), 300);
    }
  };

  const currentVariantConfig = notificationVariantConfig[variant];

  return (
    <NotificationBlockContainer
      isClickable={isClickable}
      isHideBoxShadow={isHideBoxShadow}
      isClicked={isClicked}
      onClick={handleClick}
      backgroundColor={currentVariantConfig.defaultState.backgroundColor}
      borderColor={currentVariantConfig.defaultState.borderColor}
      color={currentVariantConfig.defaultState.color}
      hoverBackgroundColor={currentVariantConfig.hoverState.backgroundColor}
      hoverBorderColor={currentVariantConfig.hoverState.borderColor}
      activeBorderColor={currentVariantConfig.activeState.borderColor}
    >
      <Box display={'flex'} gap={'8px'}>
        <Box
          sx={{
            svg: {
              width: '20px',
              height: '20px',
              path: {
                fill: currentVariantConfig.defaultState.iconColor,
              },
            },
          }}
        >
          <currentVariantConfig.icon />
        </Box>
        <Typography
          variant={'t14r'}
          sx={{ wordBreak: 'break-word', pt: '1px', pr: '10px' }}
          color={labelColor || currentVariantConfig.defaultState.color}
        >
          {label}
        </Typography>
      </Box>
      {isClickable && !customBtnProps?.isShow && (
        <Box
          sx={(theme) => {
            return {
              svg: {
                path: {
                  fill: theme.palette.case.neutral.n500,
                },
              },
            };
          }}
        >
          <ArrowRightBigIcon />
        </Box>
      )}
      {customBtnProps?.isShow && (
        <Box display={'flex'} flexShrink={0}>
          <MuiButton {...customBtnProps} size={'small'} />
        </Box>
      )}
    </NotificationBlockContainer>
  );
};
